import { InjectionToken } from '@angular/core';
import type { SideMenuCategory } from './side-menu-category.model';

/**
 * Per-role side menu category configuration.
 *
 * Each brand provides its own value for this token, mapping each user role
 * to the set of {@link SideMenuCategory} items to display in the sidebar.
 */
export type SideMenuCategoriesByRole = {
  admin: SideMenuCategory[];
  buyer: SideMenuCategory[];
  government: SideMenuCategory[];
  supplier: SideMenuCategory[];
  zone: SideMenuCategory[];
};

/**
 * Injection token for the active brand's side menu category configuration.
 *
 * Provide this in each brand's `provideXxxBrandConfig()` helper alongside
 * {@link APP_BRAND_CONFIG}.
 *
 * @example
 * // In a brand provider helper:
 * { provide: SIDE_MENU_CATEGORIES_BY_ROLE, useValue: BRAND_A_SIDE_MENU_BY_ROLE }
 */
export const SIDE_MENU_CATEGORIES_BY_ROLE =
  new InjectionToken<SideMenuCategoriesByRole>('SIDE_MENU_CATEGORIES_BY_ROLE');
